import { ButtonGroup, Button } from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { clientThemePalette, CLIENT_THEME } from 'utils/clientTheme';

interface Props {
  selected: string;
  setSelected: any;
  enableDarkTheme: boolean;
  options: string[];
  clearProfile: () => void;
}

export const SWButtonGroup = ({
  selected,
  setSelected,
  enableDarkTheme,
  options,
  clearProfile,
  ...rest
}: Props) => (
  <ButtonGroup
    size="small"
    variant="outlined"
    aria-label="Basic button group"
    sx={{
      border: '1px',
      height: '40px',
      display: 'flex',
    }}
  >
    {options.map((item) => {
      const palette = enableDarkTheme
        ? clientThemePalette[CLIENT_THEME].dark
        : clientThemePalette[CLIENT_THEME].light;
      return (
        <Button
          key={item}
          sx={{
            backgroundColor:
              selected === item
                ? clientThemePalette[CLIENT_THEME].light.primary
                : enableDarkTheme
                ? palette.boxBackground
                : palette.toolBarBackground,
            color: palette.textPrimary,
            textTransform: 'none',
            height: '40px',
            paddingLeft: '15px',
            paddingRight: '15px',
            fontSize: '12px',
          }}
          onClick={() => {
            setSelected(item);
            clearProfile();
          }}
        >
          {item.charAt(0).toUpperCase() + item.slice(1)}
        </Button>
      );
    })}
  </ButtonGroup>
);
